<template>
    <section class="slider__section">
        <div
            class="slider__container"
            @mouseover="intervalStop"
            @mouseleave="intervalStart"
            v-if="images.length > 0"
            :key="'products found'"
        >
            <div class="slider__box">
                <Flicking
                    class="carousel"
                    :options="{
                        align: 'prev',
                        circular: true,
                        resizeOnContentsReady: false,
                        panelsPerView: 1,
                        dots: true
                    }"
                    @changed="resetDotsOnFlickingChanged"
                    ref="flicking"
                >
                    <div class="panel" v-for="image in images" v-if="image.id !== 39" :key="image.id">
                        <div class="image__box">
                            <img
                                :src="urlImages + '/' + image.photo"
                                :alt="image.title"
                            />
                        </div>
                    </div>
                </Flicking>
            </div>

            <div class="dots__box">
                <button
                    v-for="(dot, index) in images"
                    v-if="dot.id !== 39"
                    :key="index"
                    :class="{ active: activePanel === index }"
                    @click="moveTo(index)"
                >
                    <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="7.5" cy="7.5" r="7.5" fill="#E0E0E0" />
                    </svg>
                </button>
            </div>
        </div>

        <div class="slider__container" v-else>
            <h2 v-if="images.length === 0" :key="'products no found'">
                Продукты не найдены!
            </h2>
        </div>
    </section>
</template>

<script>
import { Flicking } from "@egjs/vue-flicking";

export default {
    components: {
        Flicking
    },

    props: {
        images: {
            type: Array,
            required: true
        },

        url: {
            type: String,
            required: false
        }
    },

    data() {
        return {
            interval: {},
            urlImages: "",

            dotsNumber: "",
            activePanel: 0
        };
    },

    methods: {
        prevSlide() {
            this.$refs.flicking.prev().catch(() => void 0);
        },

        nextSlide() {
            this.$refs.flicking.next().catch(() => void 0);
        },

        async intervalStart() {
            this.interval = setInterval(() => {
                this.$refs.flicking
                    .next()
                    .then(() => {
                        const { index } = this.$refs.flicking.getStatus();
                        this.activePanel = index;
                    })
                    .catch(() => void 0);
            }, 3000);
        },

        intervalStop() {
            clearInterval(this.interval);
        },

        setUrl() {
            if (this.url.length > 0) {
                const url = this.url.split("/");
                url.pop();
                this.urlImages = url.join("/");
            }
        },

        async moveTo(ind) {
            this.activePanel = ind;
            await this.$refs.flicking.moveTo(ind).catch(() => void 0);
            const { index } = this.$refs.flicking.getStatus();
            this.activePanel = index;
        },

        resetDotsOnFlickingChanged() {
            const { index } = this.$refs.flicking.getStatus();
            this.activePanel = index;
        }
    },

    mounted() {
        this.intervalStart();
        this.setUrl();
    },

    destroyed() {
        this.intervalStop();
    }
};
</script>

<style lang="scss" scoped>
@import url("../../../../../node_modules/@egjs/vue-flicking/dist/flicking.css");
// Or, if you have to support IE9
@import url("../../../../../node_modules/@egjs/vue-flicking/dist/flicking-inline.css");

@media only screen and (min-width: 1440px) {
    .slider__section {
        margin-right: 9px !important;
    }
}

@media only screen and (min-width: 1200px) {
    .slider__section {
        .slider__container {
            padding: 10px 0 0 10px;
        }
    }
}

@media only screen and (max-width: 1200px) {
    .slider__section {
        .slider__container {
            margin-top: 10px;
        }
    }
}

.slider__section {
    height: 100%;
    max-height: 548.5px;

    .slider__container {
        position: relative;
        height: 100%;

        .slider__box {
            height: 100%;
            border-radius: 3px;
            overflow: hidden;

            .image__box {
                width: 100% !important;
                height: 100% !important;

                img {
                    width: 100% !important;
                    height: 100% !important;
                    object-fit: cover;
                    border-radius: 3px;
                }
            }
        }
    }

    // .slick-dots {
    //     position: relative;
    // }

    // .exp {
    //     img {
    //         height: 200px;
    //         width: 200px;
    //     }
    // }

    // .carousel {
    //     max-width: 1440px;
    //     overflow-x: hidden;

    //     .product__box {
    //         padding-top: 10px;
    //         padding-bottom: 10px;
    //     }
    // }

    .nav__box {
        z-index: 9999;

        .prev {
            position: absolute;
            top: 50%;
            left: 0;
            margin-left: 15px;
        }

        .next {
            position: absolute;
            top: 50%;
            right: 0;
            margin-right: 15px;
        }

        button {
            width: 40px;
            height: 40px;

            border: none;
            outline: none;
            font-size: 16px;
            border-radius: 4px;

            color: #ffffff;
            background-color: #3E5C45;

            &:hover {
                cursor: pointer;
                background-color: #6C9672;
            }
        }

        button.disabled {
            background-color: #e0e0e0;
            color: #808080;
        }
    }

    .dots__box {
        position: absolute;
        z-index: 10;
        bottom: 15px;
        left: 50%;
        transform: translateX(-50%);

        button {
            padding: 0;
            margin: 0 5px;

            background-color: transparent;
            outline: none;
            border: none;

            &:hover {
                cursor: pointer;
            }
        }

        .active {
            svg {
                circle {
                    fill: white;
                }
            }

            svg {
                border-radius: 50%;
                box-shadow: 0 0 3px rgb(0 0 0 / 15%);
            }
        }
    }
}

@media only screen and (max-width: 550px) {
    .box {
        .nav__box {
            display: none;
        }
    }

    .dots__box {
        bottom: 6px;
        button {
            svg {
                width: 8px;
                height: 8px;
            }
        }
    }
}
</style>
